export const TEMPORARY_PNR_BLOCK = [];

export const CHECKIN_PNR_BLOCK = [];
